import { useForm } from 'react-hook-form'
import { useState } from 'react'

import { z } from 'zod';

import { Botao, Cores, LogoMicroUniverso, Rodape, Textfield, Icone, Corpo } from '@componentes-mu/componentes-mu'
import { zodResolver } from '@hookform/resolvers/zod'

import { LoginApiRequest } from '../../types/user/types'
import estiloLogin from './styles.module.scss'

const Schema = z.object({
  usuario: z.string().min(1, "Usuário é obrigatório"),
  senha: z.string().min(1, "Senha é obrigatória"),
})

type LoginProps = {
  onLoginFormSubmit: (formData: LoginApiRequest) => void
}

const Login = ({ onLoginFormSubmit }: LoginProps) => {
  const {
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm<LoginApiRequest>({
    resolver: zodResolver(Schema),
    defaultValues: {
      usuario: "",
      senha: "",
    },
  })
  const [isCapsLockActive, setIsCapsLockActive] = useState(false)

  return (
    <>
      <div
        className={estiloLogin.container}
        style={{ backgroundColor: Cores.GradacaoNeutros.CinzaFillMU100 }}
      >
        <div className={estiloLogin.conteudo}>
          <div className={estiloLogin.conteudoEsquerda}>
            <div className={estiloLogin.logo}>
              <LogoMicroUniverso
                tipoLogo="largeLogoBlue"
                Largura="80vw"
                Altura="auto"
                style={{
                  maxWidth: '100%',
                }}
              />
            </div>
          </div>
          <div className={estiloLogin.conteudoDireita}>
            <form onSubmit={handleSubmit(onLoginFormSubmit)} className={estiloLogin.loginForm}>
              <div className={estiloLogin.cabecalho}>
                <LogoMicroUniverso
                  tipoLogo="MULabelBlue_Slogan"
                  Altura="auto"
                  Largura="100%"
                  style={{
                    maxWidth: '100%',
                  }}
                />
              </div>
              <div className={estiloLogin.inputs}>
                <div className={estiloLogin.campos}>
                  <div className={estiloLogin.textfield}>
                    <Textfield
                      valor={watch('usuario')}
                      autoCompletar="username"
                      iconeInputField=""
                      titulo="Usuário"
                      placeholder="Digite seu usuário..."
                      onChange={(e) => setValue('usuario', e || '')}
                      autofocus
                      variante={errors.usuario ? 'error' : 'regular'}
                      conteudoDeAjuda={{
                        texto: errors.usuario?.message || '',
                        estado: errors.usuario ? 'error' : 'regular',
                      }}
                    />
                  </div>
                </div>
                <div className={estiloLogin.campos}>
                  <div className={estiloLogin.textfield}>
                    <Textfield
                      senha
                      autoCompletar="current-password"
                      valor={watch('senha')}
                      iconeInputField=""
                      titulo="Senha"
                      placeholder="Digite sua senha..."
                      onChange={(e) => setValue('senha', e || '')}
                      onKeyDown={(e) => setIsCapsLockActive(e.getModifierState('CapsLock'))}
                      onKeyUp={(e) => setIsCapsLockActive(e.getModifierState('CapsLock'))}
                      variante={errors.senha ? 'error' : 'regular'}
                      conteudoDeAjuda={{
                        texto: errors.senha?.message || '',
                        estado: errors.senha ? 'error' : 'regular',
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className={estiloLogin.botaoContainer}>
                {isCapsLockActive && (
                  <div className={estiloLogin.capsLockWarning}>
                    <Icone
                      nome="warning"
                      cor={Cores.MensagensDoSistema.LaranjaMU}
                      largura="30px"
                      altura="30px"
                      style={{ marginRight: "10px" }}
                    />
                    <Corpo
                      tipo={"body1"}
                      negrito={700}
                      tag="h1"
                      cor={Cores.MensagensDoSistema.LaranjaMU}
                    >
                      CapsLock Ativado!
                    </Corpo>
                  </div>
                )}
                <Botao tipoComportamento="submit">Acessar</Botao>
              </div>
            </form>
          </div>
        </div>
        <div className={estiloLogin.rodape}>
          <Rodape telaLogin={true} sombreado={false} />
        </div>
      </div>
    </>
  )
}

export default Login
